import { Dispatch, useState } from "react"

export interface IUserFilters {
    status: string | undefined,
    codeOrder: string | undefined,
    setCodeOrder: Dispatch<string | undefined>,
    onSelectStatus: (status: number) => void,
    codeOrNameProd: string | undefined,
    onChangeProd: (value: string | undefined) => void
}

export const useFilters = (): IUserFilters => {
    const [codeOrder, setCodeOrderInput] = useState<string>();
    const [status, setStatus] = useState<string>();
    const [codeOrNameProd, setCodeOrNameProd] = useState<string>();

    function onSelectStatus(status: number | string) {
        if(status == '' || !status || String(status)?.length == 0) {
            setStatus(undefined);
            return
        }
        switch (status) {
            case "1":
                setStatus("gerada")
                return
            case "2":
                setStatus("auditada")
                return
            case "3":
                setStatus("finalizada")
                return
            default:
                setStatus(undefined)
        }
    }

    function setCodeOrder(vl: string|undefined) {
        if(!vl || vl == '') {
            setCodeOrderInput(undefined);
            return
        }
        setCodeOrderInput(vl);
    }

    function onChangeProd(value: string | undefined) {
        if (!value || value?.length == 0) {
            setCodeOrNameProd(undefined);
            return;
        }

        let clearInput = value?.trimEnd()?.replace(/[<|>|}|script|alert|select|insert]/g, '');
        setCodeOrNameProd(clearInput);
    }

    return {
        status,
        codeOrder,
        setCodeOrder,
        onSelectStatus,
        codeOrNameProd,
        onChangeProd
    }
}